module.exports = __webpack_public_path__ + "media/images/icon_blank-0eb6f3637c008f9c1291a9bb95b393f6.png";